import { render, staticRenderFns } from "./AiText.vue?vue&type=template&id=3b8ff48b&scoped=true&"
import script from "./AiText.vue?vue&type=script&lang=js&"
export * from "./AiText.vue?vue&type=script&lang=js&"
import style0 from "./cards.css?vue&type=style&index=0&id=3b8ff48b&scoped=true&lang=css&"
import style1 from "./AiText.vue?vue&type=style&index=1&id=3b8ff48b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8ff48b",
  null
  
)

export default component.exports